<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="用户id">
              <a-input v-model="queryParam.openId" placeholder="请输入用户id" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <!-- 查看区域 -->
    <a-modal
      title="查看"
      :visible="viewVisible"
      @cancel="HandleCancel"
      width="1000px"
    >
      <a-row type="flex" justify="space-around" align="middle">
        <a-col :span="4">
          <p class="height-100">
            <img :src="getHeadImageView(this.userInfo.headimgurl)" />
          </p>
        </a-col>
        <a-col :span="12">
          <a-row>
            <a-col :span="12"> 昵称: {{ this.userInfo.nickname }} </a-col>
            <a-col :span="12"> 性别: {{ this.userInfo.sex }} </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              地区: {{ this.userInfo.country }} {{ this.userInfo.province }}
              {{ this.userInfo.city }}
            </a-col>
            <a-col :span="12" v-if="this.userInfo.subscribeTime">
              关注时间: {{ this.userInfo.subscribeTime }}
            </a-col>
            <a-col :span="12" v-if="this.userInfo.phone">
              手机号: {{ this.userInfo.phone }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12"> unionid: {{ this.userInfo.unionid }} </a-col>
            <a-col :span="12" v-if="this.userInfo.tagidList">
              标签: {{ this.userInfo.tagidList }}
            </a-col>
            <a-col :span="12" v-if="this.userInfo.createTime">
              创建时间: {{ this.userInfo.createTime }}
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-modal>
    <!-- 查看区域END -->
    <!--  获取积分明细表单  -->
    <template>
      <div>
        <j-modal
          :visible="visible"
          :width="width"
          :title="title"
          switchFullscreen
          cancelText="关闭"
          @ok="handleOk"
          @cancel="handleCancle"
        >
          <!-- table区域-begin -->
          <div>
            <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
              <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
              <a style="margin-left: 24px" @click="onClearSelected">清空</a>
            </div>-->
            <a-table
              ref="table"
              size="middle"
              bordered
              rowKey="id"
              :columns="commonColumns"
              :dataSource="integralDataSource"
              :pagination="false"
              :loading="loading"
              class="j-table-force-nowrap"
              @change="handleTableChange"
            >
            </a-table>
          </div>
          <!-- 分页 -->
          <div style="margin-top: 10px;margin-left: 200px">
            <a-pagination
              v-model="detailQuery.pageNo"
              :page-size-options="detailQuery.pageSizeOptions"
              :total="detailQuery.total"
              show-size-changer
              :page-size="detailQuery.pageSize"
              @showSizeChange="addOnShowSizeChange"
              @change="addOnChangeCurrent"
            >
              <template slot="buildOptionText" slot-scope="props">
                <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
                <span v-if="props.value === '50'">全部</span>
              </template>
            </a-pagination>
          </div>
        </j-modal>
      </div>
    </template>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="getAddIntegralDetail(record, '0')">积分获取明细</a>
          <a-divider type="vertical" />
          <a @click="getAddIntegralDetail(record, '1')">积分兑换明细</a>
          <a-divider type="vertical" />
          <a @click="getUserInfo(record.openId)">查看用户信息</a>
        </span>
      </a-table>
    </div>

    <!-- 分页 -->
    <div style="margin-left: 300px;margin-top: 10px;">
      <a-pagination
        v-model="query.pageNo"
        :page-size-options="query.pageSizeOptions"
        :total="query.total"
        show-size-changer
        :page-size="query.pageSize"
        @showSizeChange="onShowSizeChange"
        @change="onChangeCurrent"
      >
        <template slot="buildOptionText" slot-scope="props">
          <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
          <span v-if="props.value === '50'">全部</span>
        </template>
      </a-pagination>
    </div>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { getAction, getFileAccessHttpUrl } from '@/api/manage';
import { mixinDevice } from '@/utils/mixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';

export default {
  name: 'IntegralRecord',
  mixins: [JeecgListMixin, mixinDevice],
  components: {},
  data() {
    return {
      width: 800,
      visible: false,
      viewVisible: false,
      userInfo: {},
      openId: '',
      title: '',
      description: '用户积分明细管理页面',
      query: {
        pageSizeOptions: ['5', '10', '20', '40', '50'],
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      detailQuery: {
        pageSizeOptions: ['5', '10', '20', '40', '50'],
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      integralDataSource: [],
      queryParam: {},
      // 表头
      columns: [
        {
          title: '用户ID',
          align: 'center',
          dataIndex: 'openId',
          width: 130
        },
        {
          title: '用户总积分',
          align: 'center',
          dataIndex: 'integralNum',
          width: 50
        },
        {
          title: '积分更新时间',
          align: 'center',
          dataIndex: 'lastModifyTime',
          width: 100
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 200,
          //fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      commonColumns: [],
      integralAddColumns: [
        {
          title: '用户ID',
          align: 'center',
          dataIndex: 'openId'
        },
        {
          title: '积分流水号',
          align: 'center',
          dataIndex: 'recordNo'
        },
        {
          title: '积分获取途径',
          align: 'center',
          dataIndex: 'integralType_dictText'
        },
        {
          title: '获得积分数值',
          align: 'center',
          dataIndex: 'recordNum'
        },
        /*{
            title:'关联活动',
            align:"center",
            dataIndex: 'activityType',
          },*/
        {
          title: '流水时间',
          align: 'center',
          dataIndex: 'createTime'
        }
      ],
      integralMinusColumns: [
        {
          title: '用户ID',
          align: 'center',
          dataIndex: 'openId'
        },
        {
          title: '积分流水号',
          align: 'center',
          dataIndex: 'recordNo'
        },
        {
          title: '消耗积分',
          align: 'center',
          dataIndex: 'recordNum'
        },
        {
          title: '兑换奖品ID',
          align: 'center',
          dataIndex: 'prizesId'
        },
        {
          title: '兑换奖品名称',
          align: 'center',
          dataIndex: 'prizesName'
        },
        /*{
            title:'发奖状态',
            align:"center",
            dataIndex: 'isDeal',
          },*/
        {
          title: '流水时间',
          align: 'center',
          dataIndex: 'createTime'
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_MARKETING + '/integral/record/list',
        getRecordDetail:
          process.env.VUE_APP_CMS_MARKETING + '/integral/record/getRecordDetail'
      },
      dictOptions: {}
    };
  },
  computed: {},
  created() {
    this.loadData2();
  },
  methods: {
    getHeadImageView: function(headimgurl) {
      return getFileAccessHttpUrl(headimgurl);
    },
    loadData2() {
      this.dataSource = [];
      getAction(this.url.list, {
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        openId: this.queryParam.openId
      }).then(res => {
        if (res.success) {
          this.dataSource = res.result.records;
          this.query.total = res.result.total;
          console.log('dataSource', this.dataSource);
        }
      });
    },

    searchQuery() {
      this.loadData2();
    },

    initDictConfig() {},
    HandleCancel() {
      this.userInfo = {};
      this.viewVisible = false;
    },
    getUserInfo(openId) {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wxUser/queryByOpenId', {
        openId: openId
      }).then(res => {
        if (res.success && res.result) {
          const record = res.result;
          this.userInfo = res.result;
          this.userInfo.headimgurl = !record.avatarUrl
            ? record.headimgurl
            : record.avatarUrl;
          this.userInfo.nickname = !record.nickName
            ? record.nickname
            : record.nickName;
          this.userInfo.sex = !record.gender ? record.sex : record.gender;
          if (this.userInfo.sex == 1 || this.userInfo.sex == 1.0) {
            this.userInfo.sex = '男';
          }
          if (this.userInfo.sex == 2 || this.userInfo.sex == 2.0) {
            this.userInfo.sex = '女';
          }
          if (this.userInfo.sex == 0 || this.userInfo.sex == 0.0) {
            this.userInfo.sex = '未知';
          }
          console.log(this.userInfo);
          this.viewVisible = true;
        }
        if (res.result == null) {
          this.$message.warn('用户不存在！');
        }
      });
    },
    getAddIntegralDetail(record, record_type) {
      this.openId = record.openId;
      var parms = {
        recordType: record_type,
        openId: this.openId,
        pageNo: 1,
        pageSize: 10
      };
      this.visible = true;
      if (record_type === '0') {
        this.title = '用户积分获取明细';
        this.commonColumns = this.integralAddColumns;
        //获取积分
        getAction(this.url.getRecordDetail, parms).then(res => {
          if (res.success) {
            this.integralDataSource = res.result.records;
            this.detailQuery.total = res.result.total;
            console.log('integralAddDataSource', this.integralDataSource);
          }
        });
      } else {
        this.title = '用户积分兑换明细';
        this.commonColumns = this.integralMinusColumns;
        //兑换积分
        getAction(this.url.getRecordDetail, parms).then(res => {
          if (res.success) {
            this.integralDataSource = res.result.records;
            this.detailQuery.total = res.result.total;
            console.log('integralAddDataSource', this.integralDataSource);
          }
        });
      }
    },
    handleOk(e) {
      console.log(e);
      this.openId = '';
      this.visible = false;
    },
    handleCancle(e) {
      console.log(e);
      this.openId = '';
      this.visible = false;
    },
    onShowSizeChange(current, pageSize) {
      this.query.pageSize = pageSize;
      this.loadData2();
    },
    onChangeCurrent(current) {
      this.query.pageNo = current;
      this.loadData2();
    },
    addOnShowSizeChange(current, pageSize) {
      this.detailQuery.pageSize = pageSize;
      var parms = null;
      if (this.title === '用户积分获取明细') {
        parms = {
          recordType: '0',
          openId: this.openId,
          pageNo: this.detailQuery.pageNo,
          pageSize: this.detailQuery.pageSize
        };
      } else if (this.title === '用户积分兑换明细') {
        parms = {
          recordType: '1',
          openId: this.openId,
          pageNo: this.detailQuery.pageNo,
          pageSize: this.detailQuery.pageSize
        };
      }
      getAction(this.url.getRecordDetail, parms).then(res => {
        if (res.success) {
          this.integralDataSource = res.result.records;
          this.detailQuery.total = res.result.total;
          console.log('integralAddDataSource', this.integralDataSource);
        }
      });
    },
    addOnChangeCurrent(current) {
      this.detailQuery.pageNo = current;
      var parms = null;
      if (this.title === '用户积分获取明细') {
        parms = {
          recordType: '0',
          openId: this.openId,
          pageNo: this.detailQuery.pageNo,
          pageSize: this.detailQuery.pageSize
        };
      } else if (this.title === '用户积分兑换明细') {
        parms = {
          recordType: '1',
          openId: this.openId,
          pageNo: this.detailQuery.pageNo,
          pageSize: this.detailQuery.pageSize
        };
      }
      getAction(this.url.getRecordDetail, parms).then(res => {
        if (res.success) {
          this.integralDataSource = res.result.records;
          this.detailQuery.total = res.result.total;
          console.log('integralAddDataSource', this.integralDataSource);
        }
      });
    }
  }
};
</script>

<style scoped>
@import '~@assets/less/common.less';
</style>
